import React, { Component } from 'react'

export default class Header extends Component {
  render() {
    return (
      <div className='header'>
        <h1>Affirbisiaks</h1>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/Header.js